<template>
    <div>
      <!-- 头部 -->
      <top></top>
      <div class="main">
        <navMenu :active="active"></navMenu>
        <div class="content" v-loading.fullscreen.lock="loading">
          <div class="go-back" @click="goBack">返回</div>
          <div class="main-title">企业联系人</div>
          <!-- 表单信息 -->
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            class="bus-ruleForm"
            label-position="top"
          >
            <el-form-item label="公司名称">
              <el-input v-model="userdata.name_cn" disabled></el-input>
            </el-form-item>
            <el-form-item label="公司英文名称">
              <el-input v-model="userdata.name_en" disabled></el-input>
            </el-form-item>
            <el-form-item label="联系人类型" prop="contacts_type">
              <el-select v-model="ruleForm.contacts_type" placeholder="请选择联系人类型">
                <el-option
                  v-for="item in contacts_type"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="岗位状态" prop="contacts_station">
                <el-select v-model="ruleForm.contacts_station" placeholder="请选择岗位状态">
                <el-option
                  v-for="item in contacts_station"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="姓名" prop="fullname">
              <el-input v-model="ruleForm.fullname" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="固话" prop="telephone">
              <el-input v-model="ruleForm.telephone" placeholder="请输入固话"></el-input>
            </el-form-item>
            <el-form-item label="Email" prop="email" >
              <el-input v-model="ruleForm.email" placeholder="请输入Email"></el-input>
            </el-form-item>
            <el-form-item label="手机" prop="mobile">
              <el-input
                placeholder="请输入手机"
                v-model.number="ruleForm.mobile"
                maxlength="11"
              ></el-input>
            </el-form-item> 
            <el-form-item label="传真">
              <el-input
                placeholder="请输入传真"
                v-model.number="ruleForm.facsimile"
              ></el-input>
            </el-form-item> 
            <el-form-item label="邮编">
              <el-input
                placeholder="请输入邮编"
                v-model.number="ruleForm.postal_code"
              ></el-input>
            </el-form-item> 
            <el-form-item label="职务" prop="position">
              <el-input  placeholder="请输入职务" v-model="ruleForm.position"></el-input>
            </el-form-item>
            <el-form-item
              label="联系人地址"
              prop="contacts_address"
              class="form-width"
            >
              <el-input
                placeholder="请输入联系人地址"
                type="textarea"
                :rows="5"
                v-model="ruleForm.contacts_address"
                maxlength="600"
                show-word-limit
                resize="none"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="公司地址"
              prop="company_address"
              class="form-width"
            >
              <el-input
                placeholder="请输入公司地址"
                type="textarea"
                :rows="5"
                v-model="ruleForm.company_address"
                maxlength="600"
                show-word-limit
                resize="none"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="bus-btn">

            <el-button @click="submitForm('ruleForm', 'submit')"
              >确定</el-button
            >
          </div>
        </div>
      </div>

    </div>
  </template>
  
  <script>
  import {
    addContacts,
    editContacts,
    getContactsDetail,
  } from "@/api/api";
  import top from "../components/top.vue"; //头部
  import navMenu from "../components/navMenu.vue"; //左侧步骤条

  export default {
    components: { top, navMenu },
    name: "busInformation",
    data() {
      return {
        type:'',
        userdata:{},
        active: 1,
        headers: {},
        loading: false,
        contacts_type:[],
        contacts_station:[],
        mark:'',
        ruleForm: {
          contacts_long_id:'',//联系人长ID
          contacts_type:'',//联系人类型
          contacts_station:'',//岗位状态
          fullname:'',//姓名
          telephone:'',//固定电话
          email:'',//邮箱
          mobile:'',//手机号
          facsimile:'',//传真
          position:'',//职位
          contacts_address:'',//联系人地址
          company_address:'',//公司地址
          postal_code:'',//邮编

      },
        rules: {
            contacts_type: [{ required: true, message: "请选择联系人类型", trigger: "change" }],
            fullname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
            telephone: [{ required: true, message: "请输入固话", trigger: "blur" }],
            email: [{ required: true, message: "请输邮箱", trigger: "blur" }, {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
],
            mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }, {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: "blur",
          },
],
            position: [{ required: true, message: "请输入职位", trigger: "blur" }],
            contacts_address: [{ required: true, message: "请输入联系人地址", trigger: "blur" }],
            company_address: [{ required: true, message: "请输入公司地址", trigger: "blur" }],
        },
      };
    },
    mounted() {
      this.contacts_type = JSON.parse(localStorage.getItem("dictdata")).contacts_type;
      this.contacts_station = JSON.parse(localStorage.getItem("dictdata")).contacts_station;
      let userdata = JSON.parse(localStorage.getItem("userdata"));
      this.userdata=userdata;
      let stepMenuList = JSON.parse(localStorage.getItem("menu"));
      this.stepMenuList = stepMenuList;
      var index = stepMenuList.findIndex(function (item) {
        return item.link_url == "conference";
      });
      this.active = index;
      this.type = this.$route.query.type;
      this.mark=this.$route.query.mark;
      this.contacts_long_id = this.$route.query.contacts_long_id;
      
      
      let token = this.$store.state.token;
      //console.log(token);
      this.headers = {
        Authorization: token,
      };
      //获取联系人信息
      this.getInfor(this.contacts_long_id);
    },
    created() {},
    watch: {},
    methods: {
      //获取展商信息
      getInfor(contacts_long_id) {
        if(contacts_long_id){
            getContactsDetail({contacts_long_id}).then((res) => {
                if (res.data.code == 1) {
                    let { data } = res.data;
                    console.log(data, '=====data')
                    let {
                        contacts_address,
                        company_address,
                        contacts_type,
                        contacts_station,
                        fullname,
                        telephone,
                        email,
                        mobile,
                        facsimile,
                        position,
                        postal_code,
                        contacts_long_id

                    } = data;

                    let infor = {
                        contacts_address,
                        company_address,
                        contacts_type,
                        contacts_station,
                        fullname,
                        telephone,
                        email,
                        mobile,
                        facsimile,
                        position,
                        postal_code,
                        contacts_long_id
                    };
                    this.ruleForm = infor;
                    console.log(this.ruleForm, "===this.ruleForm");

                    this.loading = false;
                }
            })
                .catch((err) => {});
        }
      },

      // 返回
      goBack() {
        this.$router.back();
      },
      //滑动到错误对应位置
      scrollToFormError() {
        // 获取第一个校验错误的元素
        const element = document.querySelectorAll(".el-form-item__error")[0];
        // 滚动到错误元素对应位置
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      },

      // 提交
      submitForm(formName) {
        
        this.$refs[formName].validate((valid) => {
          if (valid) { 
            this.submitInfo()
          }
        });
      },

      //提交审核
      submitInfo() {
        this.loading = true;
        let data = this.ruleForm;
        data.mark=this.mark;
        if(this.type=='add'){//新增
            this.addData(data)
        }else if(this.type=='edit'){//修改
            this.editData(data)
        }
        
      },
      //新增
      addData(data){
        
        addContacts(data).then((res) => {
            console.log(res.data, "===新增数据");
            this.loading = false;
            if (res.data.code == 1) {
              this.$message.success("新增联系人成功！");
              // 返回上一页
              setTimeout(() => {
                this.goBack();
              }, 1000);
            } else {
              this.$message.warning(res.data.message);
            }
          })
          .catch((err) => {
            this.loading = false;
          });
      },
       //编辑
       editData(data){
        editContacts(data).then((res) => {
            console.log(res.data, "===修改数据");
            this.loading = false;
            if (res.data.code == 1) {
              this.$message.success("修改联系人成功！");
              // 返回上一页
              setTimeout(() => {
                this.goBack();
              }, 1000);
            } else {
              this.$message.warning(res.data.message);
            }
          })
          .catch((err) => {
            this.loading = false;
          });
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .content {
    padding-bottom: 40px;
    .main-title {
      margin-top: 40px;
      margin-bottom: 35px;
    }
    .bus-ruleForm {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 100px;
      width: 100%;
      background: #fff;
      padding: 40px;
      box-sizing: border-box;
      .el-form-item {
        width: 27%;
        margin-right: 60px;
        .el-select,
        .el-cascader {
          width: 100%;
        }
        .el-input__inner {
          height: 50px;
          line-height: 50px;
        }
        .el-tag {
          min-width: 100px;
          height: 38px;
          color: #48484a;
          margin-right: 8px;
          margin-bottom: 8px;
          font-size: 12px;
          line-height: 38px;
          text-align: center;
          background: #fff;
          border-radius: 6px;
          cursor: pointer;
          border: 1px solid #e0e0e0;
        }
        .select {
          color: #1677ff;
          border-color: #1677ff;
        }
        .el-textarea__inner {
          border-radius: 9px;
        }
      }
  
      .form-width {
        width: 80%;
      }
      .form-label {
        .el-tag + .el-tag {
          margin-left: 10px;
          margin-bottom: 10px;
        }
        .button-new-tag,
        .input-new-tag {
          width: 200px;
          height: 50px;
          color: #48484a;
          display: inline-block;
          margin-right: 8px;
          font-size: 18px;
          line-height: 50px;
          text-align: center;
          background: #fff;
          border-radius: 9px;
          border: 1px solid #e0e0e0;
        }
        .input-new-tag {
          border: 0 none;
        }
      }
      .product-class {
        align-items: center;
        .el-select {
          width: 200px;
          margin-right: 12px;
        }
        .el-button {
          min-width: auto;
          width: 23px;
          height: 23px;
          font-size: 12px;
          text-align: center;
          line-height: 23px;
          padding: 0;
          position: inherit;
          transform: none;
          border-radius: 50%;
        }
        .el-button + .el-button {
          margin-left: 20px;
        }
        .el-button--danger {
          color: #fff !important;
          background-color: #f56c6c !important;
          border-color: #f56c6c !important;
        }
        .el-button--primary {
          color: #fff !important;
          background-color: #409eff !important;
          border-color: #409eff !important;
        }
      }
      .product-class + .product-class {
        margin-top: 20px;
      }
    }
  }
  .bus-btn {
    text-align: center;
    .el-button {
      position: inherit;
      transform: translateX(0);
    }
    .save-draft {
      color: #2690E6;
      background: #fff;
      border: 1px solid #008DFF;
    }
  }
  </style>
  <style lang="scss">
  .bus-ruleForm .el-form-item {
    .el-form-item__label,
    .el-form-item__content {
      font-size: 15px;
    }
    .el-form-item__label {
      line-height: 21px;
      padding-bottom: 13px;
    }
    .el-input__inner {
      height: 38px;
      font-size: 12px;
      line-height: 38px;
      border-radius: 6px;
      border-color: #e0e0e0;
    }
  }
  .avatar-uploader {
    width: 152px;
    height: 152px;
    overflow: hidden;
    background: #f5f5f5;
    border-radius: 2px;
    border: 1px dashed #bfbfbf;
    .el-upload {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .add-wrap {
      line-height: 25px;
      color: #8c8c8c;
      font-size: 12px;
      .title {
        color: #434343;
        font-size: 16px;
      }
      .el-icon-plus {
        font-size: 40px;
        color: #999;
        margin: 20px auto 10px;
      }
    }
    .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      max-width: 175px;
      max-height: 175px;
      display: block;
    }
    .upload-img {
      .upload-span {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba($color: #000, $alpha: 0.4);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: all 0.1s;
        .upload-icon {
          color: #fff;
          font-size: 36px;
        }
      }
      &:hover {
        .upload-span {
          opacity: 1;
        }
      }
    }
  }
  .poster-uploader {
    width: 384px;
    overflow: hidden;
    background: #fff;
    border-radius: 9px;
    border: 1px solid #bfbfbf;
    .el-upload {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .add-wrap {
      line-height: 25px;
      color: #8c8c8c;
      font-size: 12px;
      .title {
        color: #434343;
        font-size: 16px;
      }
      .el-icon-tickets {
        font-size: 40px;
        color: #1677ff;
        margin: 20px auto 10px;
      }
    }
  }
  @media only screen and (max-width: 767px) {
    .el-button{
      font-size:15px !important;
    }
    .content{
      padding: 30px 0 80px 0 !important;
      margin: initial !important;
      .bus-ruleForm{
        margin: auto;
        width: 90% !important;
        .el-form-item{
          width: 100% !important;
          margin-right: 0 !important;
        }
      }
      .go-back{
        margin-left: 30px;
      }
      .main-title{
        margin-left: 30px;
      }
    }
  
   
    
   
  }
  </style>